import { Cart, CartItemInterface, Maybe } from '@pylot-data/pylotschema'
import { getQtyChange } from './identifyCartOperationName'

const getFirstCartItem = (cartState: Cart): CartItemInterface | undefined => {
    return !!cartState.items && cartState.items.length > 0 && cartState.items[0]
        ? cartState.items[0]
        : undefined
}

// Find updated items
// fullList is the list that has more items
const getUpdatedItems = (
    fullList: Maybe<CartItemInterface>[],
    shortList: Maybe<CartItemInterface>[]
): CartItemInterface[] | [] => {
    const updatedItems: CartItemInterface[] = []
    fullList.forEach((fullListItem) => {
        if (!fullListItem) {
            return
        }
        const shortListItem = shortList.find(
            (item) => item && item.uid === fullListItem.uid
        )
        // This item has been deleted/added in the latest cart update
        if (!shortListItem) {
            updatedItems.push(fullListItem)
            return
        }
        const qtyChange = Math.abs(
            Number(fullListItem.quantity) - Number(shortListItem.quantity)
        )
        if (qtyChange !== 0) {
            updatedItems.push({ ...fullListItem, quantity: qtyChange })
        }
    })
    return updatedItems
}

// Find updated item (if cart state has qty changes) or return undefined
export const identifyUpdatedItems = (
    newState?: Cart,
    oldState?: Cart
): CartItemInterface[] | [] => {
    // qtyChange > 0 means that newState has more items than oldState
    const qtyChange = getQtyChange(newState, oldState)
    if (!qtyChange) {
        return []
    }
    if (!newState && oldState) {
        const firstItem = getFirstCartItem(oldState)
        return firstItem ? [firstItem] : []
    }
    if (newState && !oldState) {
        const firstItem = getFirstCartItem(newState)
        return firstItem ? [firstItem] : []
    }
    if (!newState?.items || !oldState?.items) {
        return []
    }
    return qtyChange > 0
        ? getUpdatedItems(newState.items, oldState.items)
        : getUpdatedItems(oldState.items, newState.items)
}
